import { Injectable } from "@angular/core";
import { RemoteDatabaseRefreshToken } from "@shared/Models/Workflow/remote-database-refresh-token.model";
import { BehaviorSubject, Observable } from "rxjs";;
//import { RemoteDatabaseRefreshToken } from "../models/Database/remote-database-password.model";

@Injectable({
    providedIn: 'root'
})
export class RemoteDatabaseConnectionService {
    remoteDatabaseSubject: BehaviorSubject<RemoteDatabaseRefreshToken[]>;
    remoteDatabaseConnection$: Observable<RemoteDatabaseRefreshToken[]>;
    constructor(){
        this.remoteDatabaseSubject = new BehaviorSubject<RemoteDatabaseRefreshToken[]>([]);
        this.remoteDatabaseConnection$ = this.remoteDatabaseSubject.asObservable();
    }
}